import { createSlice } from "@reduxjs/toolkit";
import { animateCss } from "../../../pages/TosterAlert";
import {
  empanelmentFetchDocumentAction,
  empanelmentLoginAction,
  empanelmentOptionsAction,
  empanelmentOTPValidationAction,
  empanelmentPersonalDetailsAction,
  empanelmentProfessionalRegistrationAction,
  empanelmentRegisterAction,
  empanelmentRegisterDetailsAction,
  newRegistrationAction,
} from "../../actions/empanelment/empanelmentAction";
import { resetDataAndLogout } from "../../../helpers/auth";

const empanelmentInitialState = {
  data: [],
  formData: [],
  document: [],
  loading: false,
};

const empanelmentSlice = createSlice({
  name: "case",
  initialState: empanelmentInitialState,
  reducers: {
    resetMappingDetailsReducer: (state, action) => {
      // state.caseMappingDetails.mappingDetail = [];
      // state.caseMappingDetails.mappingTemplate = [];
      return state;
    },
  },
  extraReducers: (builder) =>
    builder
      .addCase(empanelmentOTPValidationAction.pending, (state, action) => {
        state.loading = true;
        return state;
      })
      .addCase(empanelmentOTPValidationAction.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(empanelmentOTPValidationAction.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(empanelmentRegisterDetailsAction.pending, (state, action) => {
        state.loading = true;
        return state;
      })
      .addCase(empanelmentLoginAction.pending, (state, action) => {
        state.loading = true;
        return state;
      })
      .addCase(empanelmentLoginAction.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(empanelmentLoginAction.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(empanelmentRegisterDetailsAction.fulfilled, (state, action) => {
        state.data = action.payload;
        state.formData = action.payload.formData;

        state.loading = false;
      })
      .addCase(empanelmentRegisterDetailsAction.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(empanelmentOptionsAction.pending, (state, action) => {
        state.loading = true;
        return state;
      })
      .addCase(empanelmentOptionsAction.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(empanelmentOptionsAction.rejected, (state, action) => {
        // resetDataAndLogout();
        state.loading = false;
        return state;
      })

      .addCase(
        empanelmentProfessionalRegistrationAction.pending,
        (state, action) => {
          state.loading = true;
          return state;
        }
      )
      .addCase(
        empanelmentProfessionalRegistrationAction.fulfilled,
        (state, action) => {
          state.loading = false;
        }
      )
      .addCase(
        empanelmentProfessionalRegistrationAction.rejected,
        (state, action) => {
          state.loading = false;
        }
      )
      .addCase(empanelmentFetchDocumentAction.pending, (state, action) => {
        state.loading = true;
        return state;
      })
      .addCase(empanelmentFetchDocumentAction.fulfilled, (state, action) => {
        state.document = action.payload;
        state.loading = false;
        return state;
      })
      .addCase(empanelmentFetchDocumentAction.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(empanelmentPersonalDetailsAction.pending, (state, action) => {
        state.loading = true;
        return state;
      })
      .addCase(empanelmentPersonalDetailsAction.fulfilled, (state, action) => {
        // state.document = action.payload;
        state.loading = false;
        return state;
      })
      .addCase(empanelmentPersonalDetailsAction.rejected, (state, action) => {
        state.loading = false;
      }),
});

export const {
  // resetMappingDetailsReducer,
} = empanelmentSlice.actions;
export default empanelmentSlice.reducer;
